<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer004" role="doc-foreword">
<p class="fl-fl-roman"><b>Noelle Marchand</b> is a native Houstonian living out her childhood dream of being a writer. She graduated summa cum laude from Houston Baptist University in 2012, earning a bachelor’s degree in mass communications and speech communications. She loves exploring new books and new cities. When she’s not scribbling out her latest manuscript, you may find her pursuing one of her other passions—music, dance, history and classic movies.</p>
<p class="pl-center-bold"><b>Books by Noelle Marchand</b></p>
<p class="pl-booklist-series">Love Inspired Historical</p>
<p class="pl-booklist-miniseries"><span class="bold-italic">Bachelor List Matches</span></p>
<p class="pl-booklist-titles">The Texan’s Inherited Family</p>
<p class="pl-booklist-titles">The Texan’s Courtship Lessons</p>
<p class="pl-booklist-titles">The Texan’s Engagement Agreement</p>
<p class="pl-booklist-titles-sb">Unlawfully Wedded Bride</p>
<p class="pl-booklist-titles">The Runaway Bride</p>
<p class="pl-booklist-titles">A Texas-Made Match </p>
<p class="pl-center"><span class="roman">Visit the Author Profile page at </span><a href="http://www.LoveInspired.com" target="_blank">LoveInspired.com</a><span class="hyperlink"> for more titles</span><span class="roman">.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Author.vue?0bd3ee9f